









































































































import Vue from 'vue';
import {Component} from "vue-property-decorator";
import CarItemC from './CarItemC.vue';

@Component({
    components: {
        CarItemC
    }
})
export default class AccueilC extends Vue {

}




// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/AccueilC.vue